import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { from, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { CriminalRecordCheckService } from '@services';
import * as CriminalRecordCheckActions from './criminal-record-check.actions';

@Injectable()
export class CriminalRecordCheckEffects {
  constructor(
    private actions$: Actions,
    private criminalRecordCheckService: CriminalRecordCheckService
  ) {}

  // Create
  createCriminalRecordCheck$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CriminalRecordCheckActions.createCriminalRecordCheckDocument),
      switchMap(({ criminalRecordCheckDocument, file }) =>
        from(
          this.criminalRecordCheckService.createCriminalRecordCheckDocument(
            criminalRecordCheckDocument,
            file
          )
        ).pipe(
          map((criminalRecordCheckDocument) =>
            CriminalRecordCheckActions.createCriminalRecordCheckDocumentSuccess(
              {
                criminalRecordCheckDocument,
              }
            )
          ),
          catchError((error) =>
            of(
              CriminalRecordCheckActions.createCriminalRecordCheckDocumentFailed(
                { error }
              )
            )
          )
        )
      )
    )
  );

  //Read
  fetchCriminalRecordCheck$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CriminalRecordCheckActions.fetchLatestCriminalRecordCheckDocument),
      switchMap(() =>
        from(this.criminalRecordCheckService.getLatest()).pipe(
          map((criminalRecordCheckDocument) =>
            CriminalRecordCheckActions.fetchLatestCriminalRecordCheckDocumentSuccess(
              {
                criminalRecordCheckDocument,
              }
            )
          ),
          catchError((error) =>
            of(
              CriminalRecordCheckActions.fetchLatestCriminalRecordCheckDocumentFailed(
                {
                  error,
                }
              )
            )
          )
        )
      )
    )
  );

  // Update
  updateCriminalRecordCheck$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CriminalRecordCheckActions.updateCriminalRecordCheckDocument),
      switchMap(({ criminalRecordCheckDocument, file }) =>
        from(
          this.criminalRecordCheckService.updateCriminalRecordCheckDocument(
            criminalRecordCheckDocument,
            file
          )
        ).pipe(
          map((criminalRecordCheckDocument) =>
            CriminalRecordCheckActions.updateCriminalRecordCheckDocumentSuccess(
              {
                criminalRecordCheckDocument,
              }
            )
          ),
          catchError((error) =>
            of(
              CriminalRecordCheckActions.updateCriminalRecordCheckDocumentFailed(
                { error }
              )
            )
          )
        )
      )
    )
  );

  // Delete
  deleteCriminalRecordCheck$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CriminalRecordCheckActions.deleteCriminalRecordCheckDocument),
      switchMap(({ id }) =>
        from(this.criminalRecordCheckService.delete(id)).pipe(
          map(() =>
            CriminalRecordCheckActions.deleteCriminalRecordCheckDocumentSuccess(
              { id }
            )
          ),
          catchError((error) =>
            of(
              CriminalRecordCheckActions.deleteCriminalRecordCheckDocumentFailed(
                { error }
              )
            )
          )
        )
      )
    )
  );

  // Upload Processed User Criminal Record Check Document
  uploadProcessedCriminalRecordCheck$ = createEffect(() =>
    this.actions$.pipe(
      ofType(
        CriminalRecordCheckActions.uploadProcessedUserCriminalRecordCheckDocument
      ),
      switchMap(({ userCriminalRecordCheck, file }) =>
        from(
          this.criminalRecordCheckService.uploadProcessedUserCriminalRecordCheckDocument(
            userCriminalRecordCheck,
            file
          )
        ).pipe(
          map((userCriminalRecordCheck) =>
            CriminalRecordCheckActions.uploadProcessedUserCriminalRecordCheckDocumentSuccess(
              { userCriminalRecordCheck }
            )
          ),
          catchError((error) =>
            of(
              CriminalRecordCheckActions.uploadProcessedUserCriminalRecordCheckDocumentFailed(
                { error }
              )
            )
          )
        )
      )
    )
  );
}
